<template>
  <div>
    <div v-if="!readOnly" class="op">
      <label class="mt-1"> {{ $t('operacoes') }} </label>
      <b-form-select
        id="operation-selected"
        class="input-pentagro"
        v-model="operationSelected"
        :options="operations"
      ></b-form-select>
    </div>

    <div v-if="!readOnly" class="op">
      <label class="mt-1">{{ $t('corrente-de-entrada-de-temperatura-embibicao') }} </label>
      <b-form-select
        id="current-selected"
        class="input-pentagro"
        v-model="current"
        @change="changeCurrent()"
        :options="currents"
      ></b-form-select>
    </div>

    <div class="op" v-if="operationSelected && !readOnly">
      <label>{{ $t('quantidade-de-ternos') }} </label>
      <b-form-select class="input-pentagro" v-model="node.millingInfo">
        <b-form-select-option
          v-for="(o, i) in millingsOptions"
          :key="i"
          :value="o"
        >
          {{ i }}
        </b-form-select-option>
      </b-form-select>
    </div>

    <b-form v-if="operationSelected" class="b-layout" @submit.prevent="">
      <b-card class="card">
        <div class="inp">
          <label>{{ $t('umidade-do-bagaco') }} </label>
          <input min="0" step="0.1" v-model="umidadeC6.value" type="number" />
        </div>

        <div class="inp">
          <label>{{ $t('embebicao-fibra') }} </label>
          <input min="0" step="0.1" v-model="tx_agua.value" type="number" />
        </div>

        <div class="inp">
          <label>{{ $t('temperatura-embebicao-c') }} </label>
          <input v-model="tempEm" type="number"/>
        </div>
      </b-card>
      <b-card class="card">
        <div class="inp">
          <label>{{ $t('ocupacao-1') }} </label>
          <p>{{ this.Ocupacao.value | ParseNumber }}</p>
        </div>

        <div class="inp">
          <label>{{ $t('eficiencia-da-extracao') }} </label>
          <p>{{ this.eficienciaExtracao.value | ParseNumber }}</p>
        </div>
      </b-card>
    </b-form>
  </div>
</template>

<script>
import { millings } from "./millings";
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber, NumberFormat } from "../../utils/tools";
import { FiltersMixin } from '../../../mixins/filtersMixin';

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },

  mixins: [ FiltersMixin ],

  data() {
    return {
      umidadeC6: {},
      tx_agua: {},
      propTemp: {},
      tempEm: 0,
      Ocupacao: {},
      eficienciaExtracao: {},
      numberOfSuits: {
        name: this.$t('moenda-6-ternos'),
      },
      millingsOptions: millings,
      operations: [{ value: null, text:this.$t('selecione-uma-operacao')  }],
      operationSelected: null,
      operationAttributeList: [],
      currents: [{ value: null, text:this.$t('selecione-uma-corrente') }],
      current: null,
      attributesList: this.$t('selecione-uma-turbina') ,
      firstLoad: false,
      attrList: ["umidadeC6", "tx_agua", "Ocupacao", "eficienciaExtracao"],
    };
  },

  watch: {
    operationSelected() {
      if (this.firstLoad) {
        this.firstLoad = false;
        return;
      }

      this.operationAttributeList = SingletonEnginnering.getOperationsProperties(
        this.operationSelected
      ).filter((operation) => this.attrList.includes(operation.key));

      this.attrList.forEach((attr) => {
        this[attr] = this.operationAttributeList.find((p) => attr == p.caption);
        if (this[attr]) this[attr].value = ParseToNumber(this[attr].value);
      });
      this.updateNode();
    },

    current(value) {
      if (value) this.node.currentTempEm = value;
    },

    tempEm(value) {
      this.propTemp.value = NumberFormat(value);
      this.updateNode();
    },

    "umidadeC6.value"() {
      this.updateNode();
    },

    "tx_agua.value"() {
      this.updateNode();
    },
  },
  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.operationSelected = this.node.data[0].index;
        if (this.node.currentTempEm) {
          this.current = this.node.currentTempEm;
          this.changeCurrent();
        }
        this.firstLoad = true;
        this.loadNotInput();
      }

      this.node.data.forEach((p) => {
        this.attrList.forEach((a) => {
          if (p.caption == a) {
            p.value = ParseToNumber(p.value);
            this[a] = p;
          }
          if (p.index == this.node.currentTempEm) { 
          this.tempEm = ParseToNumber(p.value)
          this.propTemp = p
        } 
        });
      });
    },

    loadNotInput() {
      this.operationAttributeList = SingletonEnginnering.getOperationsProperties(
        this.operationSelected
      ).filter((operation) => this.attrList.includes(operation.key));
      let attrNotInput = this.attrList.slice(2);

      attrNotInput.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );
        if (this[attrName])
          this[attrName].value = ParseToNumber(this[attrName].value);
      });
    },

    updateNode() {
      let attrs = [
        this.umidadeC6.clone(),
        this.tx_agua.clone(),
      ]

      if (this.propTemp && this.propTemp.value) {
        attrs.push(this.propTemp.clone())
      }

      attrs.forEach(a => {
        a.value = NumberFormat(a.value);
      })
      this.node.attrs = attrs;
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) =>
        o.match(/Moenda2/)
      );
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },

    loadCurrents() {
      let crList = SingletonEnginnering.currents;
      this.currents.splice(1);
      crList.forEach((cr) => this.currents.push({ value: cr, text: cr }));
    },

    changeCurrent() {
      let attrs = SingletonEnginnering.getCurrentProperties(this.current);

      let props = SingletonEnginnering.getCurrentPropertiesAttributes(
        this.current,
        attrs[0]
      );

      props.forEach((p) => {
        if (p.key == "T") {
          this.tempEm = ParseToNumber(p.value);
          this.propTemp = p;
        }          
      });
    },
  },

  mounted() {
    this.loadOperation();
    this.loadCurrents();
    setTimeout(this.loadNode(), 200);
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.b-layout {
  display: flex;
  justify-content: space-between;
}

.card {
  margin: 10px;
}

input,
p {
  margin: 5px;
}
.varieables {
  width: 460px;
}
.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.op {
  margin: 2%;
}
</style>
